import React, {Component} from "react"
import PropTypes from "prop-types"
import {Link} from 'react-router-dom'
import {Badge, ButtonToolbar, Col, Glyphicon, Panel, Row} from "react-bootstrap"
import {Date, Grid} from "../../utils/index"

class WalkDetail extends Component {

	getStatusTitle(value) {
		switch (value) {
			case "ACTIVE":
				return <span><Glyphicon glyph="hourglass" title="Aktivní"/> Aktivní</span>;
			case "FINISHED":
				return <span><Glyphicon glyph="ok" title="Smazaná"/> Ukončená</span>;
			case "DELETED":
				return <span><Glyphicon glyph="remove" title="Smazaná"/> Smazaná</span>;
			default:
				return value
		}
	}

	getAddressTitle(address) {
		if (!address) {
			return null
		}
		const p = [];
		if (address.street) {
			p.push(address.street);
		}
		if (address.city) {
			p.push(address.city);
		}
		if (address.zip) {
			p.push(address.zip);
		}
		return p.join(', ');
	}


	render() {
		const {isFetchingItem, item, party, dog} = this.props;

		if (isFetchingItem || item === null) {
			return Grid.renderIsFetchingData()
		}
		return <div className={"detail"}>
			<Row key={1}>
				<Col lg={8} lgOffset={2}>
					<Panel>
						<Panel.Heading>
							Vycházka <Badge className="pull-right">{item.walkId}</Badge>
						</Panel.Heading>
						<Panel.Body>
							<table className="table table-detail">
								<colgroup>
									<col width="15%"/>
									<col width="30%"/>
									<col width="15%"/>
									<col width="15%"/>
									<col width="25%"/>
								</colgroup>
								<tbody>
								<tr>
									<th>Datum</th>
									<td>{Date.formatDate(item.walkDate)}</td>
								</tr>
								<tr>
									<th>Venčitel</th>
									<td>{party ? (party.firstName + ' ' + party.lastName
										+ ', ' + Date.formatDate(party.birthDate)
										+ ', ' + party.email) : ""}</td>
								</tr>
								<tr>
									<th>Pes</th>
									<td>{dog ? (dog.name) : ""}</td>
								</tr>
								<tr>
									<th>Stav</th>
									<td>{this.getStatusTitle(item.status)}</td>
								</tr>
								</tbody>
							</table>
						</Panel.Body>
					</Panel>
				</Col>
			</Row>
			<Row>
				<Col sm={12} className="text-center">
					<ButtonToolbar>
						<Link to={{pathname: "/vychazky/" + item.walkId + "/uprava"}} className="btn btn-success"><Glyphicon glyph="pencil"/> Upravit vycházku</Link>
					</ButtonToolbar>
				</Col>
			</Row>
		</div>
	}
}

WalkDetail.propTypes = {
	item: PropTypes.object,
	party: PropTypes.object,
	dog: PropTypes.object,
	isFetchingItem: PropTypes.bool.isRequired,
	onFetchEnums: PropTypes.func.isRequired,
	onShowModal: PropTypes.func.isRequired,
	session: PropTypes.object.isRequired
};

export default WalkDetail



// WEBPACK FOOTER //
// ./src/components/walk/WalkDetail.js